import _asyncToGenerator from "D:/\u4E91\u76D8/SynologyDrive/Synology Drive/\u6587\u4EF6/\u5BA2\u6237\u8C03\u67E5\u8868/customweb/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import http from '@/utils/http.js';
export default {
  data: function data() {
    return {
      userData: [],
      //登录成功后获取的数据
      qrCodeUrl: '',
      // 二维码图片地址
      aesKey: '',
      // 扫码 ID，用于轮询
      remainingTime: 300,
      // 二维码剩余时间（5 分钟）
      // message: '', // 提示信息
      pollingInterval: null,
      // 轮询定时器
      countdownInterval: null,
      // 倒计时定时器
      isRefreshing: false,
      // 是否正在刷新二维码
      isQrCodeExpired: false // 二维码是否失效

    };
  },
  mounted: function mounted() {
    this.fetchQrCode(); // 页面加载时获取二维码
  },
  beforeUnmount: function beforeUnmount() {
    clearInterval(this.pollingInterval); // 组件销毁时清除定时器

    clearInterval(this.countdownInterval);
  },
  methods: {
    // 从后端获取二维码
    fetchQrCode: function fetchQrCode() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _response$data$data, imageUrl, aesKey;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.isRefreshing = true;
                _context.next = 4;
                return http.get('http://gitea.smtjhd.com/api/wx/get/qrcode');

              case 4:
                response = _context.sent;
                console.log('第一个请求结果:', response.data.data);
                _response$data$data = response.data.data, imageUrl = _response$data$data.imageUrl, aesKey = _response$data$data.aesKey;
                _this.qrCodeUrl = imageUrl; // 假设后端返回二维码地址

                _this.aesKey = aesKey; // 假设后端返回扫码 ID

                _this.startPolling(); // 开始轮询检查扫码状态


                _this.startCountdown(); // 开始倒计时


                _this.message = '';
                _this.isQrCodeExpired = false;
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                _this.message = '获取二维码失败，请重试';
                console.error('获取二维码失败:', _context.t0);

              case 19:
                _context.prev = 19;
                _this.isRefreshing = false;
                return _context.finish(19);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 15, 19, 22]]);
      }))();
    },
    // 开始轮询检查扫码状态
    startPolling: function startPolling() {
      var _this2 = this;

      clearInterval(this.pollingInterval); // 清除之前的轮询

      this.pollingInterval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return http.get('http://gitea.smtjhd.com/api/wx/login/status/return/user?aesKey=' + _this2.aesKey);

              case 3:
                response = _context2.sent;
                _this2.userData = response.data.data;
                console.log('轮询结果:', _this2.userData); // 假设后端返回扫码状态，1 表示已扫码，0 表示未扫码

                if (response.data.data.loginstatus === '1') {
                  sessionStorage.setItem('aesKey', response.data.data.aesKey);

                  _this2.handleLoginSuccess(); // 扫码登录成功

                }

                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error('检查扫码状态失败:', _context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      })), 3000); // 每 2 秒轮询一次
    },
    // 开始倒计时
    startCountdown: function startCountdown() {
      var _this3 = this;

      clearInterval(this.countdownInterval); // 清除之前的倒计时

      this.remainingTime = 300; // 重置倒计时

      this.countdownInterval = setInterval(function () {
        if (_this3.remainingTime > 0) {
          _this3.remainingTime--;
        } else {
          clearInterval(_this3.countdownInterval);
          _this3.isQrCodeExpired = true; // 二维码失效
          // this.message = '二维码已过期，请刷新';
        }
      }, 1000); // 每秒更新一次
    },
    // 扫码登录成功处理
    handleLoginSuccess: function handleLoginSuccess() {
      clearInterval(this.pollingInterval); // 停止轮询

      clearInterval(this.countdownInterval); // 停止倒计时

      this.message = '扫码登录成功！'; // sessionStorage.setItem('aesKey', this.aesKey); // 存储 aesKey

      var _this$userData = this.userData,
          openid = _this$userData.openid,
          company = _this$userData.company,
          realname = _this$userData.realname,
          phone = _this$userData.phone,
          salse = _this$userData.salse;
      this.$router.push({
        path: '/demo',
        query: {
          openid: openid,
          company: company,
          realname: realname,
          phone: phone,
          salse: salse
        }
      }); // this.qrCodeUrl = ''; // 清除二维码
    },
    // 刷新二维码
    refreshQrCode: function refreshQrCode() {
      this.fetchQrCode();
    }
  }
};